// Symbol.dispose and Disposable are now provided by @types/node v20+

if (!Symbol.dispose) {
  // We are in an environment that doesn't support Symbol.dispose, so we need to define it
  (Symbol as any).dispose = Symbol('dispose')
}

export function isDisposable(obj: unknown): obj is Disposable {
  return typeof obj === 'object' && obj !== null && typeof (obj as Disposable)[Symbol.dispose] === 'function';
}
